<template>
  <div class="svg-wrap" v-loading="loading">
    <div ref="container" style="width: 100%;height:100%;overflow-x: hidden;overflow-y: auto;">
    </div>
    <el-popover placement="bottom" trigger="manual" :visible-arrow="false" :content="content" v-model="visible" popper-class="d3-scale-percent">
      <div class="btn" slot="reference" @click="visible = !visible"></div>
    </el-popover>
  </div>
</template>

<script>
import EnterpriseScience from '@/views/clue/components/enterpriseScience'
import { getEnterpriseGraph } from '@/views/clue/api/newClueApi'
import EquityStructure from '@/components/D3Tree/equityStructure'
import { v4 as uuidV4 } from 'uuid'
export default {
  name: 'InvestmentPenetration',
  components: {
    EnterpriseScience
  },
  props: {

  },
  data() {
    return {
      visible: false,
      content: '100%',
      loading: false
    }
  },
  mounted() {
    this.getEnterpriseGraph()
  },
  methods: {
    async getEnterpriseGraph() {
      this.loading = true
      const { hid, companyName } = this.$route.query
      const { code, data } = await getEnterpriseGraph({ hid, type: 3 })
      this.loading = false

      EquityStructure.prototype.emit = this.percentHandle
      const tree = new EquityStructure(this.$refs.container, {
        props: {
          label: 'name',
          children: 'child'
        }
      })

      const [kgqy] = data.child.filter(e => e.nodeType == 8)
      const treeData = { ...data, child: kgqy.child }
      tree.create(treeData)
    },
    percentHandle(scale) {
      this.visible = true
      this.content = Math.floor(scale * 100) + '%'
      this.timer && clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        this.visible = false
      }, 1000)
    },
  }
}
</script>

<style scoped lang="scss">
@import "~/src/views/clue/page/style/enterprise.scss";
</style>
